/**
 * Admin-Einstellungen → API-Einstellungen (KI-Übersetzung TP1).
 * Anbieterliste und Übersetzungs-Einstellungen teilen sich die Anbieter-Liste
 * (Auswahl Haupt-/Ersatzanbieter), deshalb lädt dieser Container sie einmal.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { aiSettingsApi, type AiProvider } from '../../lib/aiSettings';
import { AiProvidersSettings } from './AiProvidersSettings';
import { TranslationSettingsCard } from './TranslationSettingsCard';

export function ApiSettings({ dark }: { dark: boolean }) {
  const { t: tr } = useTranslation();
  const [providers, setProviders] = useState<AiProvider[]>([]);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      setProviders(await aiSettingsApi.listProviders());
      setError(null);
    } catch {
      setError(tr('settings.api.load_error'));
    }
  }, [tr]);

  // Direkt den API-Aufruf verketten statt `reload()` aufzurufen: die Lint-Regel
  // react-hooks/set-state-in-effect erkennt setState-Aufrufe innerhalb eines
  // .then()/.catch()-Callbacks als zulässiges Lade-Muster, nicht aber den
  // direkten Aufruf einer Funktion, die synchron (nach await) setState setzt.
  useEffect(() => {
    aiSettingsApi.listProviders()
      .then(ps => { setProviders(ps); setError(null); })
      .catch(() => setError(tr('settings.api.load_error')));
  }, [tr]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {error && <div style={{ color: '#b42318', fontSize: 13 }}>{error}</div>}
      <AiProvidersSettings dark={dark} providers={providers} onChanged={reload} />
      <TranslationSettingsCard dark={dark} providers={providers} />
    </div>
  );
}
